const baseurl = "https://npclsaurmitra.com/p2p-admin-svc/api/v1"
const imageurl = "https://p2p-map.s3.ap-south-1.amazonaws.com/"

export {baseurl, imageurl}